import NotificationManager from "../notification/NotificationManager";
import { LOGIN_NOTIFICATION } from "../../utils/constants/notification";
import {
  formatIdpUrl,
  resetCpmUser,
  selectTenantConfiguration,
  TenantConfiguration,
  updateAuthDataForTenantConf,
} from "../../redux/feature/settings/configurations-slice";
import { RootState, store } from "../../redux/store/store";
import { validateString } from "../../utils/helpers/ObjectCheckerHelper";

export function displayError(title: string, message: string) {
  NotificationManager.addNotification({
    key: LOGIN_NOTIFICATION,
    message: message,
    title: title,
    type: "error",
    closable: true,
    removeOnClose: true,
    isTemporary: true,
  });
}

export const tenantConfOrDisplayError = (tenantId: string): TenantConfiguration | undefined => {
  const state: RootState = store.getState();
  const tenantConfiguration = selectTenantConfiguration(state, tenantId);

  if (!tenantConfiguration) {
    displayError("Login Error", `Configuration not found for tenant ${tenantId}`);
  }
  return tenantConfiguration;
};

export const queryParams = (tenantId: string) => {
  const tenantConfiguration = tenantConfOrDisplayError(tenantId);
  const authority = encodeURIComponent(
    validateString(tenantConfiguration.idpUrl) ? tenantConfiguration.idpUrl : formatIdpUrl(tenantId)
  );
  const clientId = encodeURIComponent(tenantConfiguration.idpClientId);
  return `tenantId=${encodeURIComponent(tenantId)}&authority=${authority}&clientId=${clientId}`;
};

export const processDialogEventForTenant = (event: { error: number }, tenantId: string) => {
  switch (event.error) {
    case 12002:
      displayError(
        "Error",
        "The dialog box has been directed to a page that it cannot find or load, or the URL syntax is invalid."
      );
      break;
    case 12003:
      displayError("Error", "The dialog box has been directed to a URL with the HTTP protocol. HTTPS is required.");
      break;
    case 12006:
      // 12006 means that the user closed the dialog instead of waiting for it to close.
      // It is not known if the user completed the login or logout, so assume the user is
      // logged out and revert to the app's starting state. It does no harm for a user to
      // press the login button again even if the user is logged in.
      store.dispatch(updateAuthDataForTenantConf({ authData: undefined, tenantId: tenantId }));
      store.dispatch(resetCpmUser(tenantId));
      displayError("Error", "Login not completed");
      break;
    default:
      displayError("Error", "Unknown error in login dialog.");
      break;
  }
};

export interface AuthOutcome {
  authData: any; //to understand the needed type
}
